import _styled from "@emotion/styled/base";
var StyledDropdownWrapper = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e1urw56b0"
} : {
  target: "e1urw56b0",
  label: "StyledDropdownWrapper"
})();
export default StyledDropdownWrapper;